module.exports = __webpack_public_path__ + "img/search.87259a69.svg";